import logger from '../../utils/logger';

export function maskTextContent(text) {
  if (!text || typeof text !== 'string') return text;
  let masked = text.replace(/[$£€₦]\s*[\d,]+\.?\d*/g, '$•••••');
  masked = masked.replace(/\b\d{1,3}(,\d{3})+(\.\d{1,2})?\b/g, '•••,•••');
  masked = masked.replace(/[+-]?\d+\.?\d*%/g, '•.••%');
  masked = masked.replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '••••@••••.com');
  return masked;
}

function maskNode(node) {
  if (!node) return;
  if (node.type === 3) node.textContent = maskTextContent(node.textContent);
  if (node.childNodes) node.childNodes.forEach(maskNode);
}

export function maskRrwebEvents(events, maskedMode) {
  if (!maskedMode) return events;
  return events.map(event => {
    try {
      const cloned = JSON.parse(JSON.stringify(event));
      if (cloned.type === 2 && cloned.data?.node) maskNode(cloned.data.node);
      if (cloned.type === 3 && cloned.data) {
        if (cloned.data.source === 0 && cloned.data.texts) cloned.data.texts.forEach(t => { t.value = maskTextContent(t.value); });
        if (cloned.data.source === 5 && cloned.data.text !== undefined) cloned.data.text = maskTextContent(cloned.data.text);
      }
      return cloned;
    } catch (err) { logger.error(err); return event; }
  });
}
